<template>
  <div class="orderManage">
    <div class="tabs">
      <van-tabs
        color="#31b158"
        title-active-color="#31b158"
        title-inactive-color="#4E4E4E"
        line-height="0.04rem"
        @click="switchStatus"
      >
        <div>
          <van-tab
            :title="item.title"
            v-for="(item,index) in tableList"
            :key="index"
            title-style="font-size:0.36rem;"
            :name="index"
          ></van-tab>
        </div>
      </van-tabs>
    </div>
    <div class="list">
        <div class="search-bar">
          <span class="search-date" v-if="listQuery.s_time" @click="showCalendar = true">
            {{listQuery.s_time | toDate}} 至 {{listQuery.e_time | toDate}}
            <van-icon name="arrow-down" />
          </span>
          <span class="search-date" v-else @click="showCalendar = true">
            点击选择时间
            <van-icon name="arrow-down" />
          </span>
          <van-button v-show="listQuery.s_time&&listQuery.e_time" type="default" round size="small" style="margin-left:0.2rem" @click="resetTime">重置</van-button>
        </div>
        
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="min-height:100%">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
          <div
            class="list-item"
            v-for="(item,index) in list"
            :key="index"
            @click="toDetails(item)"
          >
            <div class="title">
              <span>订单编号：{{ item.order_sn }}</span>
              <span class="" style="color:#999" v-if="item.status=='0'">未支付</span>
              <span class="green" v-if="item.status=='1'">已结清</span>
              <span class="red" v-if="item.status=='2' && item.need_repayment_amount == item.order_amount">整单赊欠</span>
              <span class="red" v-if="item.status=='2' && item.need_repayment_amount != item.order_amount">部分赊欠</span>
              <span class="blue" v-if="item.status=='3'">作废</span>
              <span class="orange" v-if="item.status=='4'">退款</span>
            </div>
            <div class="text">
              <span class="van-ellipsis" style="width:4rem">{{item.buyer_name}}</span>
              <span>日单号：{{item.day_num}}</span>
              <!-- <span>¥ {{item.amount}}</span> -->
            </div>
            <div class="info van-ellipsis">
              <span v-for="(good_item,good_index) in item.goods" :key="good_index">{{good_index>0?'、':''}}{{good_item.name}}</span>
            </div>
            <div class="pay_type" v-if="item.status && item.need_repayment_amount != item.order_amount">
              <span>付款方式：</span>
              <img v-if="item.pay_type==1" src="@/assets/img/work/manage/orderPay_cash.png" alt="">
              <img v-if="item.pay_type==2" src="@/assets/img/work/manage/orderPay_alipay.png" alt="">
              <img v-if="item.pay_type==3" src="@/assets/img/work/manage/orderPay_wechat.png" alt="">
              <img v-if="item.pay_type==4" src="@/assets/img/work/manage/orderPay_card.png" alt="">
              <img v-if="item.pay_type==51 || item.pay_type==52 ||item.pay_type==53"  src="@/assets/img/work/manage/orderPay_pos.png" alt="">
              <span v-if="item.pay_type==1">现金</span>
              <span v-if="item.pay_type==2">支付宝</span>
              <span v-if="item.pay_type==3">微信</span>
              <span v-if="item.pay_type==4">银行卡</span>
              <span v-if="item.pay_type==51 || item.pay_type==52 ||item.pay_type==53">pos</span>
            </div>
            <div class="date">收银时间：{{item.create_time | toTime}}</div>
            <div class="creditDetail">
              <span v-if="item.discount>0">多收：￥{{item.discount}}</span>
              <span v-if="item.discount<0">优惠：￥{{Math.abs(item.discount)}}</span>
              <span v-if="item.need_repayment_amount>0">未还：<span style="color:#FF0000">￥{{item.need_repayment_amount||0}}</span></span>
              <span style="color:#262626">订单金额：￥{{item.amount}}</span>
            </div>
          </div>
          <div style="height:0.5rem"></div>
        </van-list>
      </van-pull-refresh>
    </div>

    <van-calendar v-model="showCalendar" :default-date="default_date" type="range" color="#07c160" :min-date="minDate" :max-date="maxDate"  @confirm="onConfirmDate" :allow-same-day="true"/>
  </div>
</template>

<script>
import { order_list } from "@/api/work/manage/order";
import {timestampToDate,timestampToTime,timestampToDateNewDate} from "@/utils/timestamp"
export default {
  name: "orderManage",
  data() {
    return {
      tableList: [
        { title: "全部", index: '' },
        { title: "已结清", index: 1 },
        { title: "赊欠", index: 2 },
        { title: "作废", index: 3 },
        { title: "退款", index: 4 }
      ],
      list: [],
      loading: true,
      finished: true,
      refreshing: false,
      listQuery: {
        page: 1,
        pageSize: "15",
        status: "",
        s_time:'',
        e_time:'',
      },
      showCalendar:false , // 日期选择时间
      minDate: new Date("2010/01/01"),
      maxDate: new Date(),
      default_date:[new Date(timestampToDateNewDate(new Date().getTime()/1000 - 60*60*24)),new Date()]
    };
  },
  filters: {
    toDate(t){
      return timestampToDate(t)
    },
    toTime(t){
      return timestampToTime(t)
    },
    getStatus(key) {
      let status = "";
      key = key +''
      switch (key) {
        case "1":
          status = "已结清";
          break;
        case "2":
          status = "赊欠";
          break;
        case "3":
          status = "作废";
          break;
        case "4":
          status = "已退款";
          break;
      }
      return status;
    },
  },
  created() {
    this.getList();
    this.$navigation.on('back', (to, from) => {
      if(to.route.name == 'manage_order_orderManage'){
        var listQuery = JSON.parse(JSON.stringify(this.listQuery))
        listQuery.status = listQuery.status == 0?'':listQuery.status
        listQuery.pageSize = this.list.length
        listQuery.page = 1
        console.log(listQuery)
        order_list(listQuery).then(res => {
          if (res.code == 200) {
            if (listQuery.page == 1) this.list = [];
            this.list = this.list.concat(res.data.list);
            if (
              this.list.length == res.data.totalCount ||
              res.data.list.length == 0
            ) {
              this.finished = true;
            } else {
              this.finished = false;
              this.loading = false;
            }
            this.refreshing = false;
          }
        });
      }
    })
  },
  mounted() {},
  methods: {
    resetTime(){
         this.listQuery.page= 1;
         this.listQuery.s_time='';
         this.listQuery.e_time='';
        // this.default_date=[new Date(timestampToDateNewDate(new Date().getTime()/1000 - 60*60*24)),new Date()]
        this.default_date=['','']
         this.getList();
    },
    // 获取列表
    getList() {
      var listQuery = JSON.parse(JSON.stringify(this.listQuery))
      listQuery.status = listQuery.status == 0?'':listQuery.status
      order_list(listQuery).then(res => {
        if (res.code == 200) {
          if (listQuery.page == 1) this.list = [];
          this.list = this.list.concat(res.data.list);
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.finished = true;
          } else {
            this.finished = false;
            this.loading = false;
            this.listQuery.page++;
          }
          this.refreshing = false;
        }
      });
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.refreshing = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.listQuery.page = 1;
      this.getList();
    },

    switchStatus(name) {
      this.list = []
      this.listQuery.status = name
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.listQuery.page = 1;
      this.getList();
    },

    // 选择日期范围
    onConfirmDate(date){
      this.listQuery.s_time = new Date(timestampToDateNewDate(new Date(date[0]).getTime()/1000)).getTime()/1000
      this.listQuery.e_time = new Date(timestampToDateNewDate(new Date(date[1]).getTime()/1000)).getTime()/1000+60*24*60 -1
      this.listQuery.page = 1;
      this.getList()
      this.showCalendar =false
    },

    // 去详情页
    toDetails(item){
      this.$router.push({
        path:'/manage/order/orderDetail',
        query:{
          order_sn:item.order_sn
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
.orderManage {
  .tabs{
    position: sticky;
    top: 0.88rem;
    z-index: 3;
  }
  .search-bar {
    display: flex;
    margin: 0.22rem 0.2rem 0.2rem;
    font-size: 0.28rem;
    position: relative;
    z-index: 2;
    .search-date {
      // width: 3.8rem;
      line-height: 0.56rem;
      border-radius: 0.28rem;
      background-color: #fff;
      color: #333333;
      padding: 0 0.19rem;
    }
    .search-text {
      width: 1.2rem;
      line-height: 0.56rem;
      border-radius: 0.28rem;
      background-color: #fff;
      color: #262626;
      text-align: center;
    }
  }
  .list-item {
    background-color: #fff;
    margin-bottom: 0.2rem;
    padding: 0 0.2rem;
    color: #262626;
    font-size: 0.28rem;
    overflow: hidden;
    .title {
      display: flex;
      justify-content: space-between;
      line-height: 0.67rem;
      border-bottom: 0.01rem solid #f2f2f2;
      margin-bottom: 0.1rem;
      .green {
        color: #15b320;
      }
      .orange {
        color: #f76900;
      }
      .blue {
        color: #999999;
      }
      .red {
        color: #ff0000;
      }
    }
    .text {
      font-size: 0.36rem;
      display: flex;
      justify-content: space-between;
      line-height: 0.54rem;
      span:nth-of-type(1){
        color: #262626;
        font-size: 0.36rem;
      }
      span:nth-of-type(2){
        color: #FFBA00;
        font-size: 0.28rem;
      }
    }
    .info {
      line-height: 0.54rem;
      font-size: 0.28rem;
    }
    .date {
      color: #333333;
      font-size: 0.28rem;
      margin-top: 0.09rem;
      margin-bottom: 0.1rem;
      line-height: 0.46rem;
    }
    .pay_type{
      display: flex;
      align-items: center;
      font-size: 0.28rem;
      img{
        width: 0.38rem;
        height: 0.29rem;
        margin-right: 0.06rem;
      }

    }
    .creditDetail{
      display: flex;
      justify-content: flex-end;
      padding-bottom: 0.12rem;
      color: #999;
      span{
        margin-right: 0.06rem;
      }


    }
  }
}
</style>

<style lang="less">
.orderManage{
  .tabs{
    .van-tab{
      flex-basis: 20% !important;
    }
  }
}
</style>